import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryButtonFullWidth } from '../../components/StyledButton';

const CheckInbox = () => {
   const location = useLocation();
   const { email } = location.state || {};
   const { t } = useTranslation();
   const navigate = useNavigate();

   useEffect(() => {
      if (!email) {
         navigate('/forgot-password');
      }
   }, [email, navigate]);

   return (
      <div className='relative w-full order-1 lg:order-2 pb-12'>
         <p className='font-extrabold text-4xl 2xl:text-5xl  text-dark-blue'>{t('reset.check-your-inbox')}</p>
         <p className='pt-7 font-medium'>
            {t('reset.password-reset-link')}&nbsp;{email}
         </p>
         <p className='pt-7'>{t('reset.please-check-your-email')}</p>

         <div className='grid grid-cols-1 pt-4'>
            <div className='col-span-full pt-4'>
               {/* <PrimaryButtonFullWidth to='../login'>{t('button.go-to-login')}</PrimaryButtonFullWidth>
                */}
               <PrimaryButtonFullWidth onClick={() => navigate('/login')}>
                  {t('button.go-to-login')}
               </PrimaryButtonFullWidth>
            </div>
         </div>
      </div>
   );
};

export default CheckInbox;
